import * as React from 'react';
import translate from '../../../../locale/translate';

import { formatDate } from '../../util/StringUtil';
import ISettings from './ISettings';

import { SU } from '../../../../interfaces';

interface IProps {
    title: string,
    software: SU.IPatch[],
    settings: ISettings,
}

export default class SoftwareTable extends React.Component<IProps, {}> {
    static propTypes = {
        title: React.PropTypes.string.isRequired,
        software: React.PropTypes.array,
        settings: React.PropTypes.object.isRequired,
    };

    static tr_no_patches_installed = translate.gettext('no patches installed');
    static tr_patch = translate.gettext('Patch');
    static tr_date = translate.gettext('Date');

    renderCategoryTable(patches: SU.IPatch[]) {
        let rows;
        if (patches.length) {
            rows = patches.map((patch: SU.IPatch, index: number) => {
                return (
                    <tr key={patch.identity+'-'+index}>
                        <td className="small">{patch.name} {patch.description}</td>
                        <td className="small text-right">{formatDate(patch.installedOn, 'L')}</td>
                    </tr>
                );
            });
        } else {
            rows = [
                <tr key="empty">
                    <td className="muted small" colSpan={2}>{SoftwareTable.tr_no_patches_installed}</td>
                </tr>
            ]
        }


        return <table className="table">
            <thead>
                <tr>
                    <th className="small">{SoftwareTable.tr_patch}</th>
                    <th className="col-xs-2 text-right small">{SoftwareTable.tr_date}</th>
                </tr>
            </thead>
            <tbody>
                {rows}
            </tbody>
        </table>;
    }

    render() {
        let softwareList = this.props.software;
        const { title, settings } = this.props;
        if(!settings.displayEmptySections && !softwareList.length) {
            return (<div><h5>{title}</h5></div>);
        }

        return (
            <div>
                <h5>{title}</h5>
                {this.renderCategoryTable(softwareList)}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/widget/su/listPatches/SoftwareTable.tsx